export const BaseUrl = "https://api.nativesutra.com";

export const getAssetUrl = (path) => {
  if (!path || typeof path !== "string") return undefined;

  const trimmedPath = path.trim();
  if (!trimmedPath) return undefined;

  if (/^(https?:)?\/\//i.test(trimmedPath) || trimmedPath.startsWith("data:")) {
    return trimmedPath;
  }

  return `${BaseUrl}${trimmedPath.startsWith("/") ? "" : "/"}${trimmedPath}`;
};

export const getBackgroundImage = (path) => {
  const assetUrl = getAssetUrl(path);
  return assetUrl ? `url(${assetUrl})` : undefined;
};
